import React from 'react';

function EventCard(props) {
  return (
    <a className="event_card text-white no-underline" href={`event-inner/${props.url}`}>
      <img loading="lazy" src={props.img} alt={props.name} className='rounded-lg shadow mb-2' />
      <p className="mb-3 font-normal text-sm">{props.title}</p>
      <h5 className="mb-3 text-xl font-bold tracking-tight d-flex algin-items-center">
      {props.button ? <button className='rounded-pill bg-yellow-400 text-black p-1 px-4 me-2'>
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
          <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
          </svg>
      </button> : ""}
      {props.name}
      </h5>
      <p className="mb-3">{props.description}</p>
    </a>
  )
}

export default EventCard